import { AdvancedTagMapping } from 'src/features/gateway-details/types';
import { ALLOWED_INPUTS, DATA_TYPES } from '../types';

export const calculateGridPropsValues = (
  showRelevantMode: boolean,
  values: AdvancedTagMapping,
  isMobile: boolean = false
) => {
  if (isMobile) {
    return { xs: 12 };
  } else if (
    showRelevantMode &&
    values.allowedInputs === ALLOWED_INPUTS.RANGE &&
    values.dataType === DATA_TYPES.FLOAT
  ) {
    return { xs: 6 };
  } else if (
    (showRelevantMode && values.dataType !== DATA_TYPES.FLOAT) ||
    (!showRelevantMode &&
      values.allowedInputs === ALLOWED_INPUTS.RANGE &&
      values.dataType === DATA_TYPES.FLOAT)
  ) {
    return { xs: 4 };
  } else if (
    !showRelevantMode &&
    values.allowedInputs === ALLOWED_INPUTS.PREDEFINED &&
    values.dataType === DATA_TYPES.FLOAT
  ) {
    return { xs: 8 };
  } else {
    return { xs: 6 };
  }
};

export const calculateGridPropsRelevantMode = (
  values: AdvancedTagMapping,
  isMobile: boolean = false
) => {
  if (isMobile) {
    return { xs: 12 };
  } else if (
    (values.allowedInputs === ALLOWED_INPUTS.RANGE && values.dataType === DATA_TYPES.FLOAT) ||
    (values.allowedInputs === ALLOWED_INPUTS.PREDEFINED && values.dataType === DATA_TYPES.FLOAT)
  ) {
    return { xs: 6 };
  } else if (
    values.allowedInputs === ALLOWED_INPUTS.RANGE &&
    values.dataType !== DATA_TYPES.FLOAT
  ) {
    return { xs: 4 };
  }

  return { xs: 8 };
};
